var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1724_4812)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "#251B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 13.6666H13.0003C12.2639 13.6666 11.667 14.2636 11.667 15V23C11.667 23.7363 12.2639 24.3333 13.0003 24.3333H25.0003C25.7367 24.3333 26.3337 23.7363 26.3337 23V15C26.3337 14.2636 25.7367 13.6666 25.0003 13.6666Z",
    stroke: "#251B7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 17.6666H26.3337",
    stroke: "#251B7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1724_4812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCircleIcon);
export default __webpack_public_path__ + "static/media/payment-circle-icon.3ff4b046c51c6962daf142530e281a64.svg";
export { ForwardRef as ReactComponent };